import '../../assets/index.css';var h = Object.defineProperty, x = Object.defineProperties;
var z = Object.getOwnPropertyDescriptors;
var s = Object.getOwnPropertySymbols;
var n = Object.prototype.hasOwnProperty, m = Object.prototype.propertyIsEnumerable;
var r = (e, a, o) => a in e ? h(e, a, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[a] = o, t = (e, a) => {
  for (var o in a || (a = {}))
    n.call(a, o) && r(e, o, a[o]);
  if (s)
    for (var o of s(a))
      m.call(a, o) && r(e, o, a[o]);
  return e;
}, d = (e, a) => x(e, z(a));
var c = (e, a) => {
  var o = {};
  for (var l in e)
    n.call(e, l) && a.indexOf(l) < 0 && (o[l] = e[l]);
  if (e != null && s)
    for (var l of s(e))
      a.indexOf(l) < 0 && m.call(e, l) && (o[l] = e[l]);
  return o;
};
import { jsxs as P, jsx as p } from "react/jsx-runtime";
import { forwardRef as y } from "react";
import { c as j, d as k } from "../../factory--gUH4vxz.js";
import { P as F } from "../../Paper-DkysGTue.js";
const R = "Tile-module__badge___kmcI0", w = "Tile-module__root___OLkd7 Tile-module__sizes___rfRt- Tile-module__variants___pSpu2 Tile-module__orientations___U-slG Tile-module__badged___FbguZ", B = "Tile-module__label___gzFo8", _ = {
  badge: R,
  root: w,
  label: B
}, C = {
  size: "sm",
  variant: "primary",
  orientation: "vertical"
}, b = y((e, a) => {
  const i = t(t({}, C), e), {
    badge: o,
    children: l,
    icon: u,
    orientation: T,
    size: g,
    variant: f,
    className: v
  } = i, N = c(i, [
    "badge",
    "children",
    "icon",
    "orientation",
    "size",
    "variant",
    "className"
  ]);
  return /* @__PURE__ */ P(
    F,
    d(t({
      component: "button",
      className: j(_.root, v),
      ref: a,
      mod: {
        size: g,
        orientation: T,
        variant: f,
        badged: !!o
      }
    }, N), {
      children: [
        u,
        /* @__PURE__ */ p("span", { className: _.label, children: l }),
        o && /* @__PURE__ */ p("div", { className: _.badge, children: o })
      ]
    })
  );
});
b.displayName = "Tile";
const U = k(b);
export {
  U as Tile
};
